import * as ExistSubscriptionActions from '../actions/existSubscription';
import { existSubscription$, editExistSubId$ } from '../selectors/subscription';

import ReduxAction from '../../../interfaces/ReduxAction';

export default function pickParametrsByIdSub (idSub: number): ReduxAction {
  return (disatch, getState): void => {
    disatch(ExistSubscriptionActions.editExistSubId(idSub));

    const editExistSubId = editExistSubId$(getState());

    const existDatetyimeFinish = existSubscription$(getState())
      .map(existSub => (
        existSub.id === editExistSubId
          ? existSub.date_finish : null
      )).filter(date => date);

    disatch(
      ExistSubscriptionActions.editExistSubDatetimeFinish(
        new Date(existDatetyimeFinish[0])
      ));
  };
}
